import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {Emitter} from "pixi-particles";

export class TweenParticleEmitter extends PIXI.Container {
    private _emitter:Emitter;
    private _emitterConfig:any;
    private _textures:PIXI.Texture[];

    constructor(textures:PIXI.Texture[], config:any) {
        super();
        this._textures = textures;
        this._emitterConfig = config;
    }

    public getAnimation(emitterSettings:{ scale:number, maxParticles:number }):void {
        if(this._emitter) {
            this._emitter.emit = false;
            ParticlesManager.removeEmitter(this._emitter);
        }

        this._emitterConfig.scale.start = this._emitterConfig.scale.end = emitterSettings.scale;
        this._emitterConfig.maxParticles = emitterSettings.maxParticles;

        this._emitter = new Emitter(this, this._textures, this._emitterConfig);
        ParticlesManager.addEmitter(this._emitter, true);
    }
}